<template lang="pug">
  v-dialog(v-model='dialogImportacionP3' scrollable persistent max-width='70%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline Información de Contenedores
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense class='d-flex justify-center')
                  table.tabla(border='0' width='60%' align='center')
                    tr(style="border: 1px solid grey;")
                      td(align="center")
                        div
                          span.bold(style='color: black') Contenedor
                      td(align="center")
                        div
                          span.bold(style='color: black') Sello
                      td(align="center")
                        div
                          span.bold(style='color: black') Tipo
                      td(align="center")
                        div
                          span.bold(style='color: black') Capacidad
                    tr(v-for="(contenedor, k) in contenedores" :key="k" align='center')
                      td.inputt
                        v-text-field(style='margin-bottom: -13px;' dense outlined :readonly='read' v-model='contenedor.contenedorOrd')
                      td.inputt
                        v-text-field(style='margin-bottom: -13px;' dense outlined :readonly='read' v-model='contenedor.selloOrd')
                      td.inputt
                        v-select(style='margin-bottom: -13px;' dense outlined :readonly='read' v-model='contenedor.tipoContenedorOrd' :items='tipoContenedorArray')
                      td.inputt
                        v-select(style='margin-bottom: -13px;' dense outlined :readonly='read' v-model='contenedor.capacidadContenedorOrd' :items='capacidadContenedorArray')
      v-card-actions
        v-btn(color='error' style='width: 10%' small dark @click='closePaso3')
          v-icon mdi-arrow-left-thick
          | Atras
        v-spacer
        v-btn(v-if="read === false" color='success' small dark @click='terminarGuardar()')
          v-icon mdi-content-save
          | Terminar y Guardar
        v-btn(color='blue', small dark @click='save')
          | Continuar
          v-icon mdi-arrow-right-thick
    ImportacionP4(:dialogImportacionP4='dialogImportacionP4' @close='closePaso4' @closeSave4='closeSave4')      
</template>

<script>
import { EventBus } from '../Events'
import ImportacionP4 from '../components/ImportacionP4'
export default {
  props: ['dialogImportacionP3'],
  data: () => ({
    dialogImportacionP4: false,
    contenedores: [{
      contenedorOrd: '',
      selloOrd: '',
      tipoContenedorOrd: 'High Cube',
      capacidadContenedorOrd: 0,
      piezasContenedorOrd: 0,
      pesoContenedorOrd: 0,
      piesCubicosContenedorOrd: 0,
    }],
    capacidadContenedorArray: [
      2400,
      1200
    ],
    tipoContenedorArray: [
      'Dry Van',
      'Reefer',
      'Collapsible',
      'Open Slide',
      'Flat Rack',
      'High Cube',
      'Metálicos',
      'Open Top',
      'Contenedor Cisterna',
      'Flexi-Tank'
    ],
    formP3: {},
    defaultFormP3: {},
    editedIndex: 0,
    read: false
  }),

  components: {
    ImportacionP4
  },

  created () {
    EventBus.$on('dataImportacion2', data => {
      console.log('LLEGO A PASO 3', data)
      this.contenedores = data.formP2.contenedores
      this.formP3 = data.formP2
      this.editedIndex = data.editedIndex
      this.read = data.read
    })
  },

  methods: {
    closePaso3 () {
      this.$emit('close')
    },

    closePaso4 () {
      this.dialogImportacionP4 = false
    },

    closeSave4 () {
      console.log('PASO 3')
      this.dialogImportacionP4 = false
      this.contenedores = [{
        contenedorOrd: '',
        selloOrd: '',
        tipoContenedorOrd: 'High Cube',
        capacidadContenedorOrd: 0,
        piezasContenedorOrd: 0,
        pesoContenedorOrd: 0,
        piesCubicosContenedorOrd: 0,
      }],
      console.log('PASO 4')
      this.$emit('closeSave3')
    },

    validarContenedores () {
      let bool = false
      for (let i = 0; i < this.contenedores.length; i++) {
        if (this.contenedores[i].capacidadContenedorOrd > 0 && this.contenedores[i].contenedorOrd !== '' && this.contenedores[i].selloOrd !== '') {
          bool = true
        } else {
          bool = false
        }

        if (bool === false) {
          if (this.read !== true) {
            this.$swal({
              icon: 'error',
              title: 'Error en los Contenedores!',
              text: 'No deben haber campos vacíos en los contenedores'
            })
          } else {
            this.$swal({
              icon: 'info',
              title: 'Contenedores sin data!',
              text: 'No se puede continuar, contenedores vacíos'
            })
          }
          return true
        }
      }
      return false
    },

    terminarGuardar () {
      if (!this.validarContenedores()) {
        this.formP3.contenedores = this.contenedores
      }
      this.contenedores = [{
        contenedorOrd: '',
        selloOrd: '',
        tipoContenedorOrd: 'High Cube',
        capacidadContenedorOrd: 0,
        piezasContenedorOrd: 0,
        pesoContenedorOrd: 0,
        piesCubicosContenedorOrd: 0,
      }],
      this.$emit('closeTodoP3')
    },

    save () {
      if (!this.validarContenedores()) {
        this.formP3.contenedores = this.contenedores

        // Bus a ImportacionP4.vue
        let array = {
          formP3: this.formP3,
          editedIndex: this.editedIndex,
          read: this.read
        }
        EventBus.$emit('dataImportacion3', array)
        this.dialogImportacionP4 = true
      } 
    }
  }
    
}
</script>

<style lang="scss">
  .inputt {
    padding: 0px 1px 0px 0px;
  }
  .input2 {
    padding: 5px 5px 25px 5px;
  }
  .tabla {
    margin: 5px;
  }
</style>